import { Baby, ShieldCheck } from 'lucide-react';
import { getOrderSeatRequirements } from '../utils/orderSeatRequirements';

const copy = {
  zh_cn: { title: '请准备座椅', child_seat: '儿童座椅', infant_seat: '婴儿座椅', unknown: '数量待确认' },
  zh_tw: { title: '請準備座椅', child_seat: '兒童座椅', infant_seat: '嬰兒座椅', unknown: '數量待確認' },
  ja: { title: 'シートを準備', child_seat: 'チャイルドシート', infant_seat: 'ベビーシート', unknown: '台数要確認' },
  en: { title: 'Prepare seats', child_seat: 'Child seat', infant_seat: 'Infant seat', unknown: 'Quantity to confirm' },
};
export default function OrderSeatBadges({ order, language = 'zh_cn' }) {
  const seats = getOrderSeatRequirements(order);
  if (!seats.length) return null;
  const text = copy[language] || copy.zh_cn;
  return <div className="my-3 flex flex-wrap items-center gap-2 rounded-xl border-2 border-[#e6b54b] bg-[#fff0cf] px-3 py-2 text-[#553600]" data-testid="order-seat-requirements" aria-label={text.title}>
    <span className="inline-flex items-center gap-1 text-xs font-bold"><ShieldCheck size={16} aria-hidden="true" />{text.title}</span>
    {seats.map(seat => <span key={seat.type} className="inline-flex items-center gap-1 rounded-lg bg-white/70 px-2 py-1 text-sm font-bold">
      <Baby size={18} aria-hidden="true" />{text[seat.type]} · {seat.quantity == null ? text.unknown : `× ${seat.quantity}`}
    </span>)}
  </div>;
}
